<!--我的账单详情-->
<template>
  <div class="nototalList_container">
    <Row>
      <Col :xs="{span:22,offset:1}" style="margin-top:30px;">
        <table style="width:100%" cellspacing="0" cellpadding="0" class="firstTable">
          <tr>
            <td colspan="4" style="font-size:14px;font-weight:700">总体情况</td>
          </tr>
          <tr>
            <td>提现金额</td>
            <td>{{table.amount |moneyFilter}}</td>
            <td>开户行</td>
            <td>{{table.bankName}}</td>
          </tr>
          <tr>
            <td>提现卡号</td>
            <td>{{table.cardNo}}</td>
            <td>提现手续费</td>
            <td>{{table.fee |moneyFilter}}</td>
          </tr>
          <tr>
            <td>提现时间</td>
            <td>{{table.withdrawTime | formatWithhour}}</td>
            <td>审核时间</td>
            <td>{{table.verifyTime | formatWithhour}}</td>
          </tr>
          <tr>
            <td>账单状态</td>
            <td>{{table.state}}</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </Col>
    </Row>
    <Row>
      <Col :xs="{span:22,offset:1}">
        <div style="display: flex;justify-content: center;margin-top:50px">
          <my-button @confirm="goBack">返回</my-button>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import passwordInput from '@/components/passwordInput'
  export default {
    name:'billDetails',
    components: {
      MyButton,
      passwordInput,
    },
    data() {
      return {
        table:{
          amount:'',
          bankName:'',
          cardNo:'',
          fee:'',
          verifyTime:'',
          withdrawTime:'',
          state:'',
          withdrawId:''
        },
      }
    },
    mounted() {
      ApiClient.get('/desktop/withdraw/myWithdrawDetail.do',{withdrawId:this.$route.query.id}).then(data => {
        this.table=data;
      })
    },
    methods: {
      goBack() {
        this.$router.push({
          name: 'wallet'
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .popups {
    .have_img {
      padding-top: 0;
      padding-bottom: 0
    }

    img {
      width: 80px;
      height: auto;
      display: inline-block;
      vertical-align: middle;
    }
    table {
      margin: 20px auto;
      width: 90%;
      font-size: 12px;
      border-collapse: collapse;

      tr:nth-child(2n+1) {
        background: #F8F8F8;
      }
      tr:nth-child(1) {
        background: #ECF3FB;
        font-weight: bold;
        font-size: 14px;
      }
      tr {
        td {
          height: 42px;
          padding-left: 20px;
          border: 1px solid #bbcade;
        }
        td:nth-child(2n) {
          width: 33%;
        }
        td:nth-child(2n+1) {
          width: 20%;
        }
      }
    }
  }
</style>
<style lang="less">
  .popups {
    .ivu-modal-header {
      border: 0;
    }
    .ivu-modal-footer {
      border-top: 0;
    }
    .ivu-modal-header {
      background: #f1f1f1;
    }
  }

  .popups {
    .ivu-modal-footer {
      border-top: 0;
    }
  }

  .nototalList_container {
    .firstTable {
      border-collapse: collapse;
    }
    .firstTable tr:nth-child(odd) {
      background: #f1f1f1;
    }
    .firstTable td {
      border: 1px solid #ccc;
      padding: 10px 18px;
      color: #525252;
      font-size: 12px;
    }
    .secondTable table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    .secondTable table th {
      background: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/billDetails.vue